import { isBlissTenantSlug } from '../config/hostTenants'
import { isBlissAdminHost, isBlissBasicHost } from '../config/blissBasicHost'

export type BlissBasicBackOfficeGateInput = {
  tenantSlug: string | null | undefined
  tenantName: string | null | undefined
  settings: Record<string, unknown> | undefined
  isPlatformAdmin: boolean
  hostname?: string | null
}

/** Prefer slug/name from availableTenants row — context slug can lag after tenant switch. */
export function blissBasicGateInputFromTenant(
  input: {
    tenantId: string | null | undefined
    tenantSlug: string | null | undefined
    tenantName: string | null | undefined
    settings: Record<string, unknown> | undefined
    isPlatformAdmin: boolean
    availableTenants: ReadonlyArray<{ id: string; slug?: string | null; name?: string | null }>
  },
  hostname?: string | null,
): BlissBasicBackOfficeGateInput {
  const active = input.tenantId
    ? input.availableTenants.find((t) => t.id === input.tenantId)
    : undefined
  return {
    tenantSlug: active?.slug ?? input.tenantSlug,
    tenantName: active?.name ?? input.tenantName,
    settings: input.settings,
    isPlatformAdmin: input.isPlatformAdmin,
    hostname,
  }
}

/** Beach Bumz and other Bliss Basic partners — slug or name/settings fallback. */
export function isBlissBasicPartnerTenant(
  tenantSlug: string | null | undefined,
  tenantName?: string | null,
  settings?: Record<string, unknown>,
): boolean {
  if (tenantSlug === 'beach-bumz') return true
  if (settings?.blissBasicPartner === true) return true
  const name = (tenantName ?? '').toLowerCase()
  if (name.includes('beach bumz') || name.includes('beachbumz')) return true
  return false
}

/** Tenants that manage Bliss Basic landing catalog from the partner studio. */
export function tenantUsesBlissBasicBackOffice(
  slug: string | null | undefined,
  tenantName?: string | null,
  settings?: Record<string, unknown>,
): boolean {
  if (!slug && !tenantName) return false
  if (isBlissBasicPartnerTenant(slug, tenantName, settings)) return true
  if (slug && isBlissTenantSlug(slug)) return true
  return false
}

export function shouldUseBlissBasicBackOffice(input: BlissBasicBackOfficeGateInput): boolean {
  // admin.blissbunkbeds.com is Master Control for Bliss staff — never the partner catalog.
  if (isBlissAdminHost(input.hostname)) return false

  const slug = input.tenantSlug
  const settings = input.settings
  const partner = isBlissBasicPartnerTenant(slug, input.tenantName, settings)

  if (!partner && !tenantUsesBlissBasicBackOffice(slug, input.tenantName, settings)) {
    return false
  }

  const onBasicHost = isBlissBasicHost(input.hostname)

  if (partner || onBasicHost) return true

  return !input.isPlatformAdmin
}
